import React from 'react';
import { getEntityId, getEntityType } from '@shared/utils/entity';
import { formatHotSpotToApi } from '../hot-spot-container/hot-spot-container.utils';
import { ErrorMessage } from './hot-spot-modal.styles';

export const handleSaveHotSpotField = async ({
    selectedHotSpot,
    changeHotSpotField,
    saveHotSpot,
    validateHotSpot,
    objectSelected,
}) => {
    const fieldsWithError = await validateHotSpot(selectedHotSpot);
    changeHotSpotField('fieldsWithError', fieldsWithError);

    if (!fieldsWithError.length) {
        const formatted = formatHotSpotToApi(selectedHotSpot,
            getEntityType(objectSelected),
            getEntityId(objectSelected));
        saveHotSpot({
            hotSpot: formatted,
        });
    }
};

export const handleCreateCategory = ({
    newCategory,
    createCategory,
    changeHotSpotField,
    selectedHotSpot,
}) => {
    createCategory({ newCategory });
    changeHotSpotField(
        'selectedCategories',
        [
            ...selectedHotSpot.selectedCategories,
            { label: newCategory },
        ],
    );
};

interface ErrorMessageProps {
    showError: boolean;
    message?: string;
}

export const ShowErrorMessage = ({ showError, message }: ErrorMessageProps) => (
    showError ? (<ErrorMessage>{message}</ErrorMessage>) : null
);
